import React, { useState, useEffect, useRef } from "react";
import DataBarChart from "../../../common/DataBarChart/DataBarChart";
import { useGetBookedOrdersChartDataByUserIdQuery } from "../diagramsSlice";
import LoadingSpinner from "../../../common/LoadingSpinner/LoadingSpinner";
import { selectCurrentUser } from "../../../../features/auth/authSlice";
import { useSelector } from "react-redux";
import useInterval from "../../../../hooks/UseInterval";

const BookedOrdersBarChart = ({
  width,
  height,
  isAutomated,
  isDisabled,
  timeInterval,
  fontSize,
  margin,
}) => {
  const [type, setType] = useState("today");

  function handleChildClick(value) {
    setType(value);
  }
  const user = useSelector(selectCurrentUser);

  const {
    data: bookedOrdersChartData,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetBookedOrdersChartDataByUserIdQuery({
    userId: user.userID,
    type: type,
  });

  const [bookedOrdersData, setBookedOrdersData] = useState([]);

  useEffect(() => {
    if (bookedOrdersChartData) {
      const data = bookedOrdersChartData.ids.map((id) => {
        return bookedOrdersChartData.entities[id];
      });
      setBookedOrdersData(data);
    }
  }, [bookedOrdersChartData, type]);

  return (
    <div className="chart-container" id="barchart-container">
      {isLoading && <LoadingSpinner />}
      {bookedOrdersData.length > 0 && (
        <DataBarChart
          chartData={bookedOrdersData}
          title={"Booked Orders"}
          category={"bookedOrdersBar"}
          width={width}
          height={height}
          handleFilter={handleChildClick}
          isAutomated={isAutomated}
          isDisabled={isDisabled}
          timeInterval={timeInterval}
          refetch={refetch}
          fontSize={fontSize}
          margin={margin}
        />
      )}
    </div>
  );
};

export default BookedOrdersBarChart;
